import { Link } from "react-router-dom";
import { Sprout } from "lucide-react";
import { LANDING } from "@/constants/testIds/landing";
import { useSiteContent } from "@/lib/siteContent";

export const Footer = () => {
  const { content } = useSiteContent();
  return (
    <footer className="bg-[#FAFAFA] border-t border-[#EAEAEA]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-3">
              <span className="inline-flex items-center justify-center w-9 h-9 rounded-2xl bg-[#6B8E23] text-white">
                <Sprout size={20} strokeWidth={2.2} />
              </span>
              <span className="font-[Outfit] font-bold text-xl tracking-tight text-[#1A1A1A]">
                Waskowi
              </span>
            </div>
            <p className="text-sm text-[#666] max-w-xs leading-relaxed">
              {content.footer_tagline}
            </p>
          </div>

          <div>
            <h4 className="font-[Outfit] font-semibold text-[#1A1A1A] mb-3">
              Rechtliches
            </h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link
                  to="/impressum"
                  data-testid={LANDING.footerImpressumLink}
                  className="text-[#444] hover:text-[#6B8E23] transition-colors"
                >
                  Impressum
                </Link>
              </li>
              <li>
                <Link
                  to="/datenschutz"
                  data-testid={LANDING.footerPrivacyLink}
                  className="text-[#444] hover:text-[#6B8E23] transition-colors"
                >
                  Datenschutzerklärung
                </Link>
              </li>
              <li>
                <Link
                  to="/konto-loeschen"
                  data-testid={LANDING.footerDeletionLink}
                  className="text-[#444] hover:text-[#6B8E23] transition-colors"
                >
                  Konto & Daten löschen
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-[Outfit] font-semibold text-[#1A1A1A] mb-3">
              Kontakt
            </h4>
            <ul className="space-y-2 text-sm">
              <li>
                <a
                  href={`mailto:${content.contact_email}`}
                  data-testid={LANDING.footerContactLink}
                  className="text-[#444] hover:text-[#6B8E23] transition-colors"
                >
                  {content.contact_email}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-[#EAEAEA] flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 text-xs text-[#888]">
          <span>© {new Date().getFullYear()} Waskowi. Alle Rechte vorbehalten.</span>
          <span>Made with care in Germany</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
